import { PropsWithChildren, ReactElement, ReactNode, useEffect } from "react";

interface IConditionProps<T> {
	check: T | undefined | null | boolean;
	failFn?: () => void;
	failDisplay?: ReactNode;
	children: ReactNode | ((item: T) => ReactNode);
}

const Condition = <T extends Record<string, unknown>>({
	check,
	failFn,
	children,
	failDisplay = null,
}: PropsWithChildren<IConditionProps<T>>): ReactElement | null => {
	useEffect(() => {
		if (check) return;
		failFn?.();
	}, [check, failFn]);

	return <>{check ? children : failDisplay}</>;
};

export default Condition;
